import { Injectable, inject } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class ThemeColorService {
    private readonly _meta = inject(Meta);

    readonly TOOLBAR = '#1e293b';
    readonly GRADIENT = '#5b7fa6';
    readonly WHITE    = '#ffffff';

    set(color: string): void {
        this._meta.updateTag({ name: 'theme-color', content: color });
    }

    reset(): void {
        this.set(this.TOOLBAR);
    }
}
